import { View } from 'foundations-components/transitional/components/View';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { H3 } from 'foundations-components/transitional/components/H3';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { HubSpotForm, getPortalAccountId, getPortalHublet, getPortalEnv } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FORM_ID = '32063dfa-468a-42ad-b0a6-c8e73d5592f9';
const LEGACY_FORM_ID = 'da58f610-c218-43ca-9df5-db7cb26806dc';
export function FormExample() {
  var _getPortalHublet, _getPortalEnv;
  const portalId = getPortalAccountId();
  const region = (_getPortalHublet = getPortalHublet()) !== null && _getPortalHublet !== void 0 ? _getPortalHublet : '';
  const env = (_getPortalEnv = getPortalEnv()) !== null && _getPortalEnv !== void 0 ? _getPortalEnv : 'prod';
  if (!portalId) {
    return /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(H3, {
        children: "Form Example"
      }), /*#__PURE__*/_jsx(Paragraph, {
        children: "Portal metadata unavailable. Unable to load form."
      })]
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(H3, {
      children: "Form Example"
    }), /*#__PURE__*/_jsx(Paragraph, {
      children: "Embedded HubSpot form using the HubSpotForm component from portals-platform-lib."
    }), /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsxs(CardSection, {
        children: [/*#__PURE__*/_jsx(Paragraph, {
          children: "Modern (v2) Form"
        }), /*#__PURE__*/_jsx(HubSpotForm, {
          formId: FORM_ID,
          portalId: String(portalId),
          region: region,
          env: env
        })]
      })
    }), /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsxs(CardSection, {
        children: [/*#__PURE__*/_jsx(Paragraph, {
          children: "Legacy (v1) Form"
        }), /*#__PURE__*/_jsx(HubSpotForm, {
          formId: LEGACY_FORM_ID,
          portalId: String(portalId),
          region: region,
          env: env
        })]
      })
    })]
  });
}